import { type PropsWithChildren } from "react";

import cn from "classnames";

interface IProps extends PropsWithChildren {
  classNames?: string;
}

const FormCard = ({ children, classNames }: IProps) => {
  return (
    <div className={cn("border-boder-2 flex flex-col gap-[34px] rounded-xl border bg-white px-[24px] py-[34px] shadow-[0_4px_10px_-4px_rgba(24,39,75,0.08)]", classNames)}>
      {children}
    </div>
  );
};

export default FormCard;
